import templateUrl from './resourceActionEdit.html'

/**
 * Resource action: Edit component.
 *
 * Used directly or dynamically generated by {@link tmrResourceActions} directive.
 *
 * @example
 * <tmr-resource-action-edit
 *   resource="$ctrl.resource"
 *   destination="'app.resource.parcels.view.edit'"
 * ></tmr-resource-action-edit>
 *
 * @type {ngComponent}
 * @prop {TmrResource} resource
 * @prop {string=} destination The destination state; may be omitted if the current state is a resourceList route
 */
export const tmrResourceActionEdit = {
  ngType: 'component',
  templateUrl,
  bindings: {
    resource: '<',
    destination: '<?',
  },
}
